// extracted by mini-css-extract-plugin
export default {"autoplayContentMetadata":"s1VNK","row":"on5vy","ccIcon":"nLypd","rating":"BP32r","descriptor":"fRkjo"};